const LoadingSpinner = () => {
  return <div className="loader ease-linear rounded-full border-t-black border-2 border-t-2 h-5 w-5"></div>
}

export default LoadingSpinner
